import { _t } from '@bark/bark-core';
import { whatsappResponseLogTrackingEvent } from './whatsapp_response';

export default function () {
	const { Handlebars } = window;

	const state = {
		projectId: '',
		sellerProfileId: '',
		projectResponseId: '',
		buyerName: '',
		buyerNumberFormatted: '',
	};

	const resetState = () => {
		Object.keys(state).forEach((key) => (state[key] = ''));
	};

	const setInState = (data) => {
		for (const key in data) {
			if (state.hasOwnProperty(key)) {
				state[key] = data[key];
			}
		}
	};

	const getFromState = (key) => {
		return state.hasOwnProperty(key) ? state[key] : '';
	};

	const domElements = {
		modalId: 'whatsapp-response-feedback-modal',
		modalContainerId: 'whatsapp-response-feedback-modal-container',
	};

	const hbTemplates = {
		modalTemplate: Handlebars.compile(
			document.getElementById('whatsapp-response-feedback-modal-template').innerHTML,
		),
	};

	const show = () => {
		buildModal();
		bindListeners();
		$(`#${domElements.modalId}`).modal('show');
	};

	const buildModal = () => {
		$(`#${domElements.modalContainerId}`).empty();
		let html = hbTemplates.modalTemplate({
			heading: _t('seller_common:whatsapp-response-feedback-modal.heading', {
				buyer_public_name: state.buyerName,
			}),
			isNotOnButton: _t(
				'seller_common:whatsapp-response-feedback-modal.is-not-on-button',
			),
			couldNotMakeItWorkButton: _t(
				'seller_common:whatsapp-response-feedback-modal.could-not-make-it-work-button',
			),
			sentMessageButton: _t(
				'seller_common:whatsapp-response-feedback-modal.sent-message-button',
			),
		});
		$(`#${domElements.modalContainerId}`).append(html);
	};

	const bindListeners = () => {
		$('#js-whatsapp-response-feedback-dismiss-btn')
			.off('click.feedback-dismiss-btn')
			.on('click.feedback-dismiss-btn', function (e) {
				e.preventDefault();
				whatsappResponseLogTrackingEvent('whatsapp - dismiss', state);
				$(`#${domElements.modalId}`).modal('hide');
			});

		$('#js-whatsapp-response-feedback-is-not-on-btn')
			.off('click.is-not-on-btn')
			.on('click.is-not-on-btn', function (e) {
				e.preventDefault();
				whatsappResponseLogTrackingEvent(
					'whatsapp - conversation failure - not on whatsapp',
					state,
				);
				$(`#${domElements.modalId}`).modal('hide');
			});

		$('#js-whatsapp-response-feedback-could-not-make-it-work-btn')
			.off('click.could-not-make-it-work-btn')
			.on('click.could-not-make-it-work-btn', function (e) {
				e.preventDefault();
				whatsappResponseLogTrackingEvent(
					'whatsapp - conversation failure - too complicated',
					state,
				);
				$(`#${domElements.modalId}`).modal('hide');
			});

		$('#js-whatsapp-response-feedback-sent-message-btn')
			.off('click.sent-message-btn')
			.on('click.sent-message-btn', function (e) {
				e.preventDefault();
				whatsappResponseLogTrackingEvent('whatsapp - conversation success', state);
				$(`#${domElements.modalId}`).modal('hide');
			});
	};

	return {
		show,
		setInState,
		getFromState,
		resetState,
	};
}
